import React from "react"
import LoaderImg from "../../../assets/images/ttd/ellipsis.gif"
function Loader(){
    return(
        <div className="loader-component">
            <img src={LoaderImg} className="loader-img" />
        </div>
    )
}
export default Loader